<template>
  <div class="amount-of-unit-picker">
    <Formfield :required="required" :helpText="helpText" :label="label">
      <div class="amount-of-unit-picker__row">
        <TextInput
          class="amount-of-unit-picker__text-input"
          v-model="inputValue.amount"
          :label="textInputLabel"
          :required="required"
          :numeric="true"
        />
        <Dropdown
          class="amount-of-unit-picker__dropdown"
          v-model="inputValue.unit"
          :placeholder="dropdownPlaceholder"
          :required="required"
          :options="units"
        />
      </div>
    </Formfield>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import Formfield from "./Formfield.vue";
import TextInput from "../atoms/Inputs/TextInput.vue";
import Dropdown from "../atoms/Inputs/Dropdown.vue";
import InputBase from "../atoms/Inputs/mixins/InputBase";
import FormMixin from "../mixins/FormMixin";

/**
 * @group Questions
 * This is a combination of a TextInput and a Dropdown and is specifically made to
 * aid the user in selecting an unit and an amount.
 */
export default {
  name: "AmountOfUnitPicker",
  mixins: [BaseComponent, InputBase, FormMixin],
  components: {
    TextInput,
    Dropdown,
    Formfield,
  },
  data() {
    let setAmount = null;
    let setUnit = null;
    if (this.value !== null) {
      setAmount = this.value.amount;
      setUnit = this.value.unit;
    }
    return {
      inputValue: {
        amount: setAmount,
        unit: setUnit,
      },
    };
  },
  props: {
    // The question that is asked to the user (i.e. How far away are you?)
    label: {
      type: String,
      required: true,
    },
    // The placeholder for the number input
    textInputLabel: {
      type: String,
      required: true,
    },
    // The placeholder for the unit input
    dropdownPlaceholder: {
      type: String,
      required: true,
    },
    // The list of allowed units
    units: {
      type: Array,
      required: true,
    },
    // Hint text
    helpText: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(value) {
      this.amount = value.amount;
      this.unit = value.unit;
      this.inputValue = value;
    },
    inputValue: {
      handler(value) {
        this.$emit("input", value, this);
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";
.amount-of-unit-picker {
  width: 100%;
  max-width: 576px;
}
.amount-of-unit-picker__row {
  display: flex;
}
.amount-of-unit-picker__dropdown {
  min-width: 33%;
  margin-left: 12px;
}
</style>
